import styled, { css } from 'styled-components'

import { focusVisibleOutline } from '@subaio/components'

import { theme } from '../../../styles/theme'

type Props = {
	isChecked: boolean
	isDisabled: boolean
	isFocusVisible: boolean
	isReadOnly: boolean
	isDirty: boolean
	isInvalid: boolean
}

export const RadioCircle = styled.div<Props>`
	position: relative;
	border: 1px ${({ isReadOnly }) => (isReadOnly ? 'dashed' : 'solid')} ${({ isDisabled, isInvalid }) => {
		if (isDisabled) return theme.color.input.backgroundDisabled
		if (isInvalid) return theme.color.input.borderError
		return theme.color.input.border
	}};
	border-radius: 12px;
	width: 22px;
	height: 22px;
	outline: none;
	flex-shrink: 0;
	margin: 1px 7px 1px 0;
	transition: background-color 150ms ease-in-out, border-color 150ms ease-in-out;

	${({ isDisabled, isReadOnly }) =>
		!isDisabled &&
		!isReadOnly &&
		css`
			&:hover {
				background-color: ${theme.color.input.backgroundHover};
				border-color: ${theme.color.input.borderHover};
				cursor: pointer;
			}
		`}

	&:after {
		content: '';
		position: absolute;
		width: 12px;
		height: 12px;
		top: 4px;
		left: 4px;
		border-radius: 100%;
		background-color: ${({ isDisabled }) => (isDisabled ? theme.color.input.contentDisabled : theme.color.input.menuIndicatorActive)};
		transform: ${({ isChecked }) => (isChecked ? 'scale(1)' : 'scale(0)')};
		transform-origin: center;
		transition: transform 100ms ease-in-out;
	}

	${({ isDisabled }) => !isDisabled && focusVisibleOutline(theme.color.input.focusOutline)};
`
